import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'

Vue.use(Router)

var router = new Router({
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Root',
            component: Home
        },
        {
            path: '/Home',
            name: 'Home',
            component: Home
        }
    ]
})
export default router

router.beforeEach((to, from, next) => {
    // Redirect if fullPath begins with a hash (ignore hashes later in path)
    if (to.fullPath.substr(0, 2) === '/#') {
        const path = to.fullPath.substr(2)
        next(path)
        return
    }
    next()
})



// WEBPACK FOOTER //
// ./src/router/index.js